import { lazily } from 'react-lazily'
/**
 * Layouts
 */
import { SingleAction } from 'layout'
import Guard from 'guards/Guard'

const { RoleOraculo } = lazily(() => import('pages/home'))

const {
  ViewProceedingPendingOraculoApproval,
  ViewProceedingsApprovedByOraculo,
  ViewProceedingDetail,
} = lazily(() => import('pages/proceedings'))
/**
 * Layouts
 */
const LAYOUTS = {
  singleAction: SingleAction,
}

const basePath = '/dashboard/oraculo'

const oraculoRoutes = [
  {
    name: 'role-oraculo-home',
    path: basePath,
    element: RoleOraculo,
    suspenseFallback: null,
    childs: [
      {
        element: ViewProceedingPendingOraculoApproval,
        guard: Guard,
        guardProps: { allowedRoles: ['Oraculo'] },
        homeForRole: ['Oraculo'],
        name: 'proceedings-pending-oraculo-approval',
        path: 'expedientes-recibidos',
        index: true,
        childs: [
          {
            name: 'pendings-oraculo-approval-proceeding-details',
            path: ':proceedingId',
            layoutProps: { title: 'Detalle del lote' },
            layout: LAYOUTS.singleAction,
            element: ViewProceedingDetail,
          },
        ],
      },
      {
        element: ViewProceedingsApprovedByOraculo,
        guard: Guard,
        guardProps: { allowedRoles: ['Oraculo'] },
        name: 'proceedings-approved-by-oraculo',
        path: 'expedientes-autorizados',
        childs: [
          {
            name: 'approved-by-oraculo-approval-proceeding-details',
            path: ':proceedingId',
            layoutProps: { title: 'Detalle del lote' },
            layout: LAYOUTS.singleAction,
            element: ViewProceedingDetail,
          },
        ],
      },
    ],
  },
]

export default oraculoRoutes